/**
 * Guarda de tokens JWT.
 * - access: só em memória (não persiste — reduz superfície de XSS).
 * - refresh: em localStorage, para sobreviver a reloads (TTL 7 dias no backend).
 * O bootstrap troca o refresh por um access novo ao subir a app.
 */
const REFRESH_KEY = 'tg.refresh'

let accessToken: string | null = null

export const tokenStore = {
  getAccess(): string | null {
    return accessToken
  },
  setAccess(token: string | null): void {
    accessToken = token
  },
  getRefresh(): string | null {
    try {
      return localStorage.getItem(REFRESH_KEY)
    } catch {
      return null
    }
  },
  setRefresh(token: string | null): void {
    try {
      if (token) localStorage.setItem(REFRESH_KEY, token)
      else localStorage.removeItem(REFRESH_KEY)
    } catch {
      /* storage indisponível (modo privado) — segue só em memória */
    }
  },
  set(access: string, refresh: string): void {
    this.setAccess(access)
    this.setRefresh(refresh)
  },
  clear(): void {
    accessToken = null
    this.setRefresh(null)
  },
  hasSession(): boolean {
    return Boolean(accessToken || this.getRefresh())
  },
}
